// todo можно удалить так как не используется вроде нигде
import axios from "../../plugins/axios-common"
export default {
	actions: {
		fetchAssistantsData({commit}) {
			commit('assistantsLoading', true)
			axios.get('/shift/assistants').then((resp) => {
				commit('updateAssistantsData', resp.data)
				commit('assistantsLoading', false)
			})
		}
	},
	mutations: {
		updateAssistantsData(state, assistants) {
			state.assistants = assistants
		},
		assistantsLoading(state, loading) {
			state.assistantsLoading = loading
		}
	},
	state: {
		assistantsLoading: false,
		assistants: {}
	},
	getters: {
		assistantsData(state) {
			return state.assistants
		},
		assistantsLoading(state) {
			return state.assistantsLoading
		}
	}
}